/* tslint:disable */
/* eslint-disable */
/**
 * Supply API Gateway
 * A REST API responsible to serve and compose all supply-related data available at Taster
 *
 * The version of the OpenAPI document: 1.63
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AppResourcesProvidersManagerCategoryPageFromJSON, ConceptPageFromJSON, IncomingDeliveriesFromJSON, IncomingDeliveryItemsFromJSON, ProviderFromJSON, ProviderDeliveryScheduleCalendarFromJSON, ProviderPageFromJSON, ProviderProductFromJSON, ProviderProductPageFromJSON, ProviderProductSearchRequestToJSON, ProviderScheduleDayPageFromJSON, SearchIncomingProviderProductParamsToJSON, SearchProviderCategoriesParamsToJSON, SearchProviderConceptsParamsToJSON, } from '../models';
/**
 *
 */
export class ProvidersApi extends runtime.BaseAPI {
    /**
     * Allow an API consumer to retrieve the number of products that will be delivered to a given location. This endpoint is also retrieving the number of deliveries that will be made to bring all the purchased items.  **Scopes**: - `carts:read` - `purchase-orders:read`
     * Get the next deliveries that a kitchen should receive
     */
    getIncomingProviderDeliveriesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling getIncomingProviderDeliveries.');
            }
            if (requestParameters.locationUuid === null || requestParameters.locationUuid === undefined) {
                throw new runtime.RequiredError('locationUuid', 'Required parameter requestParameters.locationUuid was null or undefined when calling getIncomingProviderDeliveries.');
            }
            const queryParameters = {};
            if (requestParameters.locationUuid !== undefined) {
                queryParameters['location_uuid'] = requestParameters.locationUuid;
            }
            if (requestParameters.providerType !== undefined) {
                queryParameters['provider_type'] = requestParameters.providerType;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["carts:read", "purchase-orders:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/incoming`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IncomingDeliveriesFromJSON(jsonValue));
        });
    }
    /**
     * Allow an API consumer to retrieve the number of products that will be delivered to a given location. This endpoint is also retrieving the number of deliveries that will be made to bring all the purchased items.  **Scopes**: - `carts:read` - `purchase-orders:read`
     * Get the next deliveries that a kitchen should receive
     */
    getIncomingProviderDeliveries(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIncomingProviderDeliveriesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This endpoint allow an API consumer to retrieve a `Provider` resource thanks to its UUID. A `Provider` is either a `Hub` or `Supplier` resource with is containing its label and uuid alongside its type.  This endpoint **must** be called with a location UUID to help `products-manager` API know if the selected provider is available in it or not. You can help the provider selection by providing its type thanks to `provider_type` query parameter.  **Scopes**: - `providers:read`
     * Retrieve a provider thanks to its UUID
     */
    getProviderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling getProvider.');
            }
            if (requestParameters.locationUuid === null || requestParameters.locationUuid === undefined) {
                throw new runtime.RequiredError('locationUuid', 'Required parameter requestParameters.locationUuid was null or undefined when calling getProvider.');
            }
            const queryParameters = {};
            if (requestParameters.locationUuid !== undefined) {
                queryParameters['location_uuid'] = requestParameters.locationUuid;
            }
            if (requestParameters.providerType !== undefined) {
                queryParameters['provider_type'] = requestParameters.providerType;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["providers:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProviderFromJSON(jsonValue));
        });
    }
    /**
     * This endpoint allow an API consumer to retrieve a `Provider` resource thanks to its UUID. A `Provider` is either a `Hub` or `Supplier` resource with is containing its label and uuid alongside its type.  This endpoint **must** be called with a location UUID to help `products-manager` API know if the selected provider is available in it or not. You can help the provider selection by providing its type thanks to `provider_type` query parameter.  **Scopes**: - `providers:read`
     * Retrieve a provider thanks to its UUID
     */
    getProvider(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProviderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Retrieve the delivery schedule schedule of a `Provider` specified by its UUID.  **Scopes**: - `providers:read`
     * Retrieve the delivery schedule of a provider
     */
    getProviderDeliveryScheduleRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling getProviderDeliverySchedule.');
            }
            if (requestParameters.locationUuid === null || requestParameters.locationUuid === undefined) {
                throw new runtime.RequiredError('locationUuid', 'Required parameter requestParameters.locationUuid was null or undefined when calling getProviderDeliverySchedule.');
            }
            const queryParameters = {};
            if (requestParameters.locationUuid !== undefined) {
                queryParameters['location_uuid'] = requestParameters.locationUuid;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.perPage !== undefined) {
                queryParameters['per_page'] = requestParameters.perPage;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['order_by'] = requestParameters.orderBy;
            }
            if (requestParameters.desc !== undefined) {
                queryParameters['desc'] = requestParameters.desc;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["providers:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/schedule`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProviderScheduleDayPageFromJSON(jsonValue));
        });
    }
    /**
     * Retrieve the delivery schedule schedule of a `Provider` specified by its UUID.  **Scopes**: - `providers:read`
     * Retrieve the delivery schedule of a provider
     */
    getProviderDeliverySchedule(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProviderDeliveryScheduleRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Retrieve the delivery schedule calendar of a `Provider` specified by its UUID in the date range given thanks to `start_date` and `end_date` query parameters. You\'ll have to give the provider type alongside a location UUID to be able to retrieve this calendar.  **Scopes**: - `providers:read`
     * Retrieve the delivery schedule calendar of a provider
     */
    getProviderDeliveryScheduleCalendarRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling getProviderDeliveryScheduleCalendar.');
            }
            if (requestParameters.startDate === null || requestParameters.startDate === undefined) {
                throw new runtime.RequiredError('startDate', 'Required parameter requestParameters.startDate was null or undefined when calling getProviderDeliveryScheduleCalendar.');
            }
            if (requestParameters.endDate === null || requestParameters.endDate === undefined) {
                throw new runtime.RequiredError('endDate', 'Required parameter requestParameters.endDate was null or undefined when calling getProviderDeliveryScheduleCalendar.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new runtime.RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling getProviderDeliveryScheduleCalendar.');
            }
            if (requestParameters.locationUuid === null || requestParameters.locationUuid === undefined) {
                throw new runtime.RequiredError('locationUuid', 'Required parameter requestParameters.locationUuid was null or undefined when calling getProviderDeliveryScheduleCalendar.');
            }
            const queryParameters = {};
            if (requestParameters.startDate !== undefined) {
                queryParameters['start_date'] = requestParameters.startDate.toISOString().substr(0, 10);
            }
            if (requestParameters.endDate !== undefined) {
                queryParameters['end_date'] = requestParameters.endDate.toISOString().substr(0, 10);
            }
            if (requestParameters.providerType !== undefined) {
                queryParameters['provider_type'] = requestParameters.providerType;
            }
            if (requestParameters.locationUuid !== undefined) {
                queryParameters['location_uuid'] = requestParameters.locationUuid;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["providers:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/calendar`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProviderDeliveryScheduleCalendarFromJSON(jsonValue));
        });
    }
    /**
     * Retrieve the delivery schedule calendar of a `Provider` specified by its UUID in the date range given thanks to `start_date` and `end_date` query parameters. You\'ll have to give the provider type alongside a location UUID to be able to retrieve this calendar.  **Scopes**: - `providers:read`
     * Retrieve the delivery schedule calendar of a provider
     */
    getProviderDeliveryScheduleCalendar(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProviderDeliveryScheduleCalendarRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This endpoint allow an API consumer to fetch a `ProviderProduct` resource belonging to a specifed `Provider` thanks to its UUID. To use this operation, you **must** provide a location UUID in the corresponding query parameter, as it\'s used to know whether the designated `ProviderProduct` is available or not in the corresponding location.  If you provide a `cart_uuid` query parameter, we\'ll also return the quantity associated to the `ProviderProduct` in a specified cart, if it\'s containing the product. The `provider_type` helps `products-manager` to speed up its selecting process.  By default, if the product you\'re fetching has been removed from the provider you\'ve selected, then you\'ll get a `HTTP 404 Not Found` response. If you wish to retrieve the product anyway, you can use the `with_deleted` query parameter that will return the product if it has ever been associated with the provider in the past.  **Scopes**: - `products:read`
     * Retrieve a provider product thanks to its UUID
     */
    getProviderProductRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling getProviderProduct.');
            }
            if (requestParameters.productUuid === null || requestParameters.productUuid === undefined) {
                throw new runtime.RequiredError('productUuid', 'Required parameter requestParameters.productUuid was null or undefined when calling getProviderProduct.');
            }
            if (requestParameters.locationUuid === null || requestParameters.locationUuid === undefined) {
                throw new runtime.RequiredError('locationUuid', 'Required parameter requestParameters.locationUuid was null or undefined when calling getProviderProduct.');
            }
            const queryParameters = {};
            if (requestParameters.locationUuid !== undefined) {
                queryParameters['location_uuid'] = requestParameters.locationUuid;
            }
            if (requestParameters.cartUuid !== undefined) {
                queryParameters['cart_uuid'] = requestParameters.cartUuid;
            }
            if (requestParameters.providerType !== undefined) {
                queryParameters['provider_type'] = requestParameters.providerType;
            }
            if (requestParameters.withDeleted !== undefined) {
                queryParameters['with_deleted'] = requestParameters.withDeleted;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["products:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/products/{product_uuid}`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))).replace(`{${"product_uuid"}}`, encodeURIComponent(String(requestParameters.productUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProviderProductFromJSON(jsonValue));
        });
    }
    /**
     * This endpoint allow an API consumer to fetch a `ProviderProduct` resource belonging to a specifed `Provider` thanks to its UUID. To use this operation, you **must** provide a location UUID in the corresponding query parameter, as it\'s used to know whether the designated `ProviderProduct` is available or not in the corresponding location.  If you provide a `cart_uuid` query parameter, we\'ll also return the quantity associated to the `ProviderProduct` in a specified cart, if it\'s containing the product. The `provider_type` helps `products-manager` to speed up its selecting process.  By default, if the product you\'re fetching has been removed from the provider you\'ve selected, then you\'ll get a `HTTP 404 Not Found` response. If you wish to retrieve the product anyway, you can use the `with_deleted` query parameter that will return the product if it has ever been associated with the provider in the past.  **Scopes**: - `products:read`
     * Retrieve a provider product thanks to its UUID
     */
    getProviderProduct(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProviderProductRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Allow an API consumer to retrieve a paginated list of valid substitute for a specified `ProviderProduct` in the location given thanks to `location_uuid` query parameter.  Unlike the paginated list of `ProviderProduct`, you cannot choose the order of the products because they are sorted by their priority in the substitution rules.  If you provide a valid `cart_uuid` query parameter, like in `list_provider_products` operation, we\'ll add quantity already present in the selected `Cart` resource.  **Scopes**: - `products:read` - `substitutes:read`
     * Retrieve a paginated list of valid substitutes for a specified product
     */
    listProviderProductSubstitutesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling listProviderProductSubstitutes.');
            }
            if (requestParameters.productUuid === null || requestParameters.productUuid === undefined) {
                throw new runtime.RequiredError('productUuid', 'Required parameter requestParameters.productUuid was null or undefined when calling listProviderProductSubstitutes.');
            }
            if (requestParameters.locationUuid === null || requestParameters.locationUuid === undefined) {
                throw new runtime.RequiredError('locationUuid', 'Required parameter requestParameters.locationUuid was null or undefined when calling listProviderProductSubstitutes.');
            }
            const queryParameters = {};
            if (requestParameters.locationUuid !== undefined) {
                queryParameters['location_uuid'] = requestParameters.locationUuid;
            }
            if (requestParameters.cartUuid !== undefined) {
                queryParameters['cart_uuid'] = requestParameters.cartUuid;
            }
            if (requestParameters.providerType !== undefined) {
                queryParameters['provider_type'] = requestParameters.providerType;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.perPage !== undefined) {
                queryParameters['per_page'] = requestParameters.perPage;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["products:read", "substitutes:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/products/{product_uuid}/substitutes`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))).replace(`{${"product_uuid"}}`, encodeURIComponent(String(requestParameters.productUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProviderProductPageFromJSON(jsonValue));
        });
    }
    /**
     * Allow an API consumer to retrieve a paginated list of valid substitute for a specified `ProviderProduct` in the location given thanks to `location_uuid` query parameter.  Unlike the paginated list of `ProviderProduct`, you cannot choose the order of the products because they are sorted by their priority in the substitution rules.  If you provide a valid `cart_uuid` query parameter, like in `list_provider_products` operation, we\'ll add quantity already present in the selected `Cart` resource.  **Scopes**: - `products:read` - `substitutes:read`
     * Retrieve a paginated list of valid substitutes for a specified product
     */
    listProviderProductSubstitutes(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listProviderProductSubstitutesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This endpoint allow an API consumer to retrieve a paginated list of `ProviderProduct` belonging to a specified `Provider`. The `location_uuid` query parameter **must** be given, as it filters this collection by removing product that are not available in the specified location.  You can also use the following query parameters:  - `available` to either retrieve products having an Out of Stock or not; - `available_for_ordering` to either retrieve products available for ordering or not; - `category_uuid` to filter products based on their category; - `cart_uuid` to retrieve the quantity of each fetched product in the selected page in a `Cart` resource managed by `carts-manager` API. This information is exposed in `quantity_in_cart` field, and it\'s set to `null` if no related items are found, or if the query parameter is not given; - `concept_uuid` to filter products based on a concept they\'re bound to; - `label` to filter the product labels with the provided needle; - `provider_type` to help the `products-manager` to know if the specified provider UUID is the one of a hub or a supplier; - `with_deleted` to include products that has been removed from the selected provider.  **Scopes**: - `products:read`
     * Retrieve a paginated list of products bound to a specified provider
     */
    listProviderProductsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling listProviderProducts.');
            }
            if (requestParameters.locationUuid === null || requestParameters.locationUuid === undefined) {
                throw new runtime.RequiredError('locationUuid', 'Required parameter requestParameters.locationUuid was null or undefined when calling listProviderProducts.');
            }
            const queryParameters = {};
            if (requestParameters.locationUuid !== undefined) {
                queryParameters['location_uuid'] = requestParameters.locationUuid;
            }
            if (requestParameters.available !== undefined) {
                queryParameters['available'] = requestParameters.available;
            }
            if (requestParameters.availableForOrdering !== undefined) {
                queryParameters['available_for_ordering'] = requestParameters.availableForOrdering;
            }
            if (requestParameters.cartUuid !== undefined) {
                queryParameters['cart_uuid'] = requestParameters.cartUuid;
            }
            if (requestParameters.categoryUuid !== undefined) {
                queryParameters['category_uuid'] = requestParameters.categoryUuid;
            }
            if (requestParameters.conceptUuid !== undefined) {
                queryParameters['concept_uuid'] = requestParameters.conceptUuid;
            }
            if (requestParameters.providerType !== undefined) {
                queryParameters['provider_type'] = requestParameters.providerType;
            }
            if (requestParameters.label !== undefined) {
                queryParameters['label'] = requestParameters.label;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.perPage !== undefined) {
                queryParameters['per_page'] = requestParameters.perPage;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['order_by'] = requestParameters.orderBy;
            }
            if (requestParameters.desc !== undefined) {
                queryParameters['desc'] = requestParameters.desc;
            }
            if (requestParameters.withDeleted !== undefined) {
                queryParameters['with_deleted'] = requestParameters.withDeleted;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["products:read", "providers:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/products`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProviderProductPageFromJSON(jsonValue));
        });
    }
    /**
     * This endpoint allow an API consumer to retrieve a paginated list of `ProviderProduct` belonging to a specified `Provider`. The `location_uuid` query parameter **must** be given, as it filters this collection by removing product that are not available in the specified location.  You can also use the following query parameters:  - `available` to either retrieve products having an Out of Stock or not; - `available_for_ordering` to either retrieve products available for ordering or not; - `category_uuid` to filter products based on their category; - `cart_uuid` to retrieve the quantity of each fetched product in the selected page in a `Cart` resource managed by `carts-manager` API. This information is exposed in `quantity_in_cart` field, and it\'s set to `null` if no related items are found, or if the query parameter is not given; - `concept_uuid` to filter products based on a concept they\'re bound to; - `label` to filter the product labels with the provided needle; - `provider_type` to help the `products-manager` to know if the specified provider UUID is the one of a hub or a supplier; - `with_deleted` to include products that has been removed from the selected provider.  **Scopes**: - `products:read`
     * Retrieve a paginated list of products bound to a specified provider
     */
    listProviderProducts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listProviderProductsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This endpoint allow an API consumer to retrieve a paginated list of `Provider` resources. A `Provider` is either a `Hub` or `Supplier` resource with its type contained within its representation.  This collection can be filtered by the following query parameters:  - `active` to only select active providers - `location_uuid` to only select providers available to a specific location  **Scopes**: - `providers:read`
     * Retrieve a paginated list of providers
     */
    listProvidersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.locationUuid !== undefined) {
                queryParameters['location_uuid'] = requestParameters.locationUuid;
            }
            if (requestParameters.providerType !== undefined) {
                queryParameters['provider_type'] = requestParameters.providerType;
            }
            if (requestParameters.haveReminder !== undefined) {
                queryParameters['have_reminder'] = requestParameters.haveReminder;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.perPage !== undefined) {
                queryParameters['per_page'] = requestParameters.perPage;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['order_by'] = requestParameters.orderBy;
            }
            if (requestParameters.desc !== undefined) {
                queryParameters['desc'] = requestParameters.desc;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["providers:read"]);
            }
            const response = yield this.request({
                path: `/providers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPageFromJSON(jsonValue));
        });
    }
    /**
     * This endpoint allow an API consumer to retrieve a paginated list of `Provider` resources. A `Provider` is either a `Hub` or `Supplier` resource with its type contained within its representation.  This collection can be filtered by the following query parameters:  - `active` to only select active providers - `location_uuid` to only select providers available to a specific location  **Scopes**: - `providers:read`
     * Retrieve a paginated list of providers
     */
    listProviders(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listProvidersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Allow an API consumer to retrieve a list of products that will be delivered to a given location alongside the expected quantities and their delivery dates.  **Scopes**: - `carts:read` - `purchase-orders:read`
     * Search for products to be delivered from a provider
     */
    searchIncomingProviderProductDeliveriesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling searchIncomingProviderProductDeliveries.');
            }
            if (requestParameters.searchIncomingProviderProductParams === null || requestParameters.searchIncomingProviderProductParams === undefined) {
                throw new runtime.RequiredError('searchIncomingProviderProductParams', 'Required parameter requestParameters.searchIncomingProviderProductParams was null or undefined when calling searchIncomingProviderProductDeliveries.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["carts:read", "purchase-orders:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/products/incoming`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SearchIncomingProviderProductParamsToJSON(requestParameters.searchIncomingProviderProductParams),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IncomingDeliveryItemsFromJSON(jsonValue));
        });
    }
    /**
     * Allow an API consumer to retrieve a list of products that will be delivered to a given location alongside the expected quantities and their delivery dates.  **Scopes**: - `carts:read` - `purchase-orders:read`
     * Search for products to be delivered from a provider
     */
    searchIncomingProviderProductDeliveries(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchIncomingProviderProductDeliveriesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * **Scopes**: - `providers:read`
     * Retrieve categories for a given provider
     */
    searchProviderCategoriesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling searchProviderCategories.');
            }
            if (requestParameters.searchProviderCategoriesParams === null || requestParameters.searchProviderCategoriesParams === undefined) {
                throw new runtime.RequiredError('searchProviderCategoriesParams', 'Required parameter requestParameters.searchProviderCategoriesParams was null or undefined when calling searchProviderCategories.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["providers:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/categories/search`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SearchProviderCategoriesParamsToJSON(requestParameters.searchProviderCategoriesParams),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AppResourcesProvidersManagerCategoryPageFromJSON(jsonValue));
        });
    }
    /**
     * **Scopes**: - `providers:read`
     * Retrieve categories for a given provider
     */
    searchProviderCategories(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchProviderCategoriesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * **Scopes**: - `providers:read`
     * Retrieve concepts for a given provider
     */
    searchProviderConceptsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling searchProviderConcepts.');
            }
            if (requestParameters.searchProviderConceptsParams === null || requestParameters.searchProviderConceptsParams === undefined) {
                throw new runtime.RequiredError('searchProviderConceptsParams', 'Required parameter requestParameters.searchProviderConceptsParams was null or undefined when calling searchProviderConcepts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["providers:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/concepts/search`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SearchProviderConceptsParamsToJSON(requestParameters.searchProviderConceptsParams),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ConceptPageFromJSON(jsonValue));
        });
    }
    /**
     * **Scopes**: - `providers:read`
     * Retrieve concepts for a given provider
     */
    searchProviderConcepts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchProviderConceptsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This endpoint allows an API consumer to search for `ProviderProduct` resources which are satisfy constraints that are provided in the request body. If no body are provided, this endpoint will behave in the same manner that `list_provider_products` operation.  **Scopes**: - `products:read`
     * Search for provider products
     */
    searchProviderProductsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.providerUuid === null || requestParameters.providerUuid === undefined) {
                throw new runtime.RequiredError('providerUuid', 'Required parameter requestParameters.providerUuid was null or undefined when calling searchProviderProducts.');
            }
            if (requestParameters.providerProductSearchRequest === null || requestParameters.providerProductSearchRequest === undefined) {
                throw new runtime.RequiredError('providerProductSearchRequest', 'Required parameter requestParameters.providerProductSearchRequest was null or undefined when calling searchProviderProducts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["products:read", "providers:read"]);
            }
            const response = yield this.request({
                path: `/providers/{provider_uuid}/products/search`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters.providerUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProviderProductSearchRequestToJSON(requestParameters.providerProductSearchRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProviderProductPageFromJSON(jsonValue));
        });
    }
    /**
     * This endpoint allows an API consumer to search for `ProviderProduct` resources which are satisfy constraints that are provided in the request body. If no body are provided, this endpoint will behave in the same manner that `list_provider_products` operation.  **Scopes**: - `products:read`
     * Search for provider products
     */
    searchProviderProducts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchProviderProductsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const GetProviderDeliveryScheduleOrderByEnum = {
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at',
    Weekday: 'weekday',
    UnknownDefaultOpenApi: '11184809'
};
/**
 * @export
 */
export const ListProviderProductsOrderByEnum = {
    CreatedAt: 'created_at',
    Label: 'label',
    UpdatedAt: 'updated_at',
    UnknownDefaultOpenApi: '11184809'
};
/**
 * @export
 */
export const ListProvidersOrderByEnum = {
    CreatedAt: 'created_at',
    Label: 'label',
    UpdatedAt: 'updated_at',
    UnknownDefaultOpenApi: '11184809'
};
